import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    CcmodeRequest,
    CcmodeRequested,
    CcmodeRejected,
    CcmodeSetupNew,
} from "./";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import { CcmodeDashboard } from "./CcmodeDashboard";
import { useLocation } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import Cookies from "js-cookie";
import CompleteProfilePage from "../Popup/CompleteProfileFeedPopUp";

export const Ccmode = (props) => {
    const [ccmodedata, setCCModeData] = useState();
    const [loader, setLoader] = useState(true);
    const [ccmodesetting, setCCModeSetting] = useState();
    const [ccmoderules, setCCModeRules] = useState([]);
    const [updaterule, setUpdateRules] = useState(false);
    const location = useLocation();
    const [showfeed,setShowFeed] = useState(true)
    useEffect(() => {
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/getKycMessage`,
            headers: { 
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}` 
            }
        }).then((res) => {
            if (res && res?.data  && res?.data?.kycmessage && res?.data?.kycmessage?.kyc_status) {
                if(!res?.data?.showprice){
                  setShowFeed(false)
                }
            }
        }).
        catch(error => {
          if(error?.response?.data?.message === "UnAuthorized!"){
            var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            if(cookies[i] && !cookies[i].includes("view")){
              var equals = cookies[i].indexOf("=");
              var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
              document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
          }
          
          window.location.replace(`${BASE_URL}/logout`);
        }
        })
    },[])
    useEffect(() => {
        axios({
            method: "GET",
            url: `${NODE_API_URL}/INTL/fetch-ccmode`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        })
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setLoader(false);

                    setCCModeData(res.data.data);
                }
            })
            .catch((error) => {
                setLoader(false);
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            });

        axios({
            method: "get",
            url: `${NODE_API_URL}/INTL/fetch-ccmode-setting-data`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        })
            .then((res) => {
                if (res && res.data && res.data.data && res.data.data.length) {
                    setCCModeSetting(res.data.data);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            });
    }, []);

    useEffect(() => {
        axios({
            method: "get",
            url: `${NODE_API_URL}/INTL/fetch-ccmode-rules`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
        })
            .then((res) => {
                if (res && res.data && res.data.data && res.data.data.length) {
                    setCCModeRules(res.data.data);
                } else {
                    setCCModeRules([]);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            });
    }, [updaterule]);

    return (
        <>
        {showfeed?<div>
            {loader ? (
                <div
                    className="bg-white d-flex align-items-center justify-content-center container rounded"
                    style={{ height: "80vh" }}
                >
                    <div className="text-center">
                        <CircularProgress color="secondary" />
                    </div>
                </div>
            ) : (
                <>
                    <div className="card border-0 custom-card">
                        <div className="card-body">
                            {!ccmodedata ? (
                                <CcmodeRequest language={props.language} />
                            ) : (
                                ""
                            )}
                            {ccmodedata && ccmodedata.Status === 1 ? (
                                <CcmodeRequested language={props.language} />
                            ) : (
                                ""
                            )}
                            {ccmodedata &&
                            ccmodedata.Status === 2 &&
                            !ccmodesetting ? (
                                <CcmodeSetupNew
                                    userinfo={props.userinfo}
                                    language={props.language}
                                />
                            ) : (
                                ""
                            )}
                            {ccmodedata && ccmodedata.Status === 3 ? (
                                <CcmodeRejected language={props.language} />
                            ) : (
                                ""
                            )}
                            {ccmodedata &&
                            ccmodedata.Status === 2 &&
                            ccmodesetting ? (
                                <CcmodeDashboard
                                    ccmodesetting={ccmodesetting}
                                    userinfo={props.userinfo}
                                    language={props.language}
                                    tabvalue={location.state}
                                    ccmoderules={ccmoderules}
                                    setUpdateRules={setUpdateRules}
                                    updaterule={updaterule}
                                    conversionrate={props.conversionrate}
                                    symbol={props.symbol}
                                    symbolname={props.symbolname}
                                />
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                </>
            )}
        </div>:<CompleteProfilePage/>}
        </>
    );
};
